import React from 'react';
import styled from 'styled-components';

import { Nullable } from '@tager/web-core';

import ContentContainer from '@/components/ContentContainer';
import Top from '@/modules/Post/components/Top';
import { PostFull } from '@/typings/model';
import Main from '@/modules/Post/components/Main';

type Props = {
  post: Nullable<PostFull>;
};

const PostView = ({ post }: Props) => {
  return (
    <Component>
      <ContentContainer>
        <Top urlAlias={post?.urlAlias} pageName={post?.title} />
        <Main post={post} />
      </ContentContainer>
    </Component>
  );
};

export default PostView;

const Component = styled.div``;
